import React, { useContext } from 'react';
import heroBanner from '../../assets/hero-banner.jpg';
import { AuthContext } from '../../context/AuthContext';
import '../../styles/inicio.css';

function Inicio() {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <div>Cargando...</div>;

  return (
    <div className="inicio">
        <div className="hero-section" style={{ backgroundImage: `url(${heroBanner})` }}>
            <div className="hero-overlay">
                <h1>Bienvenidos a Club Nexo</h1>
                <p>Juegos de Mesa, Rol y Estrategia</p>
                <a href="/calendario" className="hero-button">Ver Calendario</a>
            </div>
        </div>
        <section className="content">
            <h2>Únete a la Diversión</h2>
            <p>
                En Club Nexo, nos apasionan los juegos de mesa, el rol y la estrategia. Organizamos eventos semanales,
                talleres y sesiones de juego para todos los niveles. ¡Ven y forma parte de nuestra comunidad!
            </p>
        </section>
    </div>
  );
}

export default Inicio;